import React, { useCallback, useMemo } from 'react';
import {
  TablePaginatedV8Core,
  CellLeftV8,
  CellDateV8,
  EyeColumnV8,
  order2Sorting,
} from 'motion-components';
import { generatePath, useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
import { isActiveColumn, gridInactiveRowStyle, gridRowSelectedStyle } from 'shared-pages/common/grid-helpfunc';
import { getRouteByName } from 'app/routes';

export const DataGrid = (props: any) => {
  const {
    data,
    dataCount,
    initPageIndex,
    onPageChange,
    loading,
    initOrderBy,
    onOrderChange,
    selected,
    setSelected,
  } = props;
  const location = useLocation<any>();
  const history = useHistory();
  const { appStore } = useRootStore();
  const { t, i18n } = useTranslation();

  const rowClicked = useCallback(
    (row) => {
      history.push({
        pathname: generatePath(getRouteByName('CntContributionTemplate'), { id: row.id }),
        state: {
          pathname: location.pathname,
          ...location.state,
        },
      });
    },
    [history, location.pathname, location.state],
  );

  const columns = useMemo(
    () => [
      EyeColumnV8(rowClicked),
      {
        id: 'name',
        header: t('Ονομασία'),
        columnName: t('Ονομασία'),
        accessorKey: 'name',
        orderByField: 'name',
        cell: CellLeftV8,
        size: 50,
      },
      {
        id: 'fromDate',
        header: t('Ισχύς από'),
        columnName: t('Ισχύς από'),
        accessorKey: 'fromDate',
        orderByField: 'fromDate',
        cell: CellDateV8,
        size: 16,
      },
      {
        id: 'tillDate',
        header: t('Ισχύς έως'),
        columnName: t('Ισχύς έως'),
        accessorKey: 'tillDate',
        orderByField: 'tillDate',
        cell: CellDateV8,
        size: 16,
      },
      isActiveColumn(t, i18n),
    ],
    [t, i18n, rowClicked],
  );

  return (
    <TablePaginatedV8Core
      loading={loading}
      id="cnt-contribution-templates-grid"
      appStore={appStore}
      columns={columns as any}
      data={data ?? []}
      dataCount={dataCount ?? 0}
      topBorderRadius={false}
      onRowClick={({ row }) => setSelected(row.original)}
      rowProps={(row: any) => {
        let style = undefined;
        if (row.original?.id === selected?.id) style = gridRowSelectedStyle;
        if (row.original?.isActive === false) style = { ...style, ...gridInactiveRowStyle };
        return { style };
      }}
      onPageChange={onPageChange}
      initPageIndex={initPageIndex}
      initSorting={order2Sorting(initOrderBy)}
      onSortByChange={(_sort, _col, orderBy) => onOrderChange(orderBy)}
    />
  );
};
